import { render } from "./CreateTicketForm.vue?vue&type=template&id=74913cde"
import script from "./CreateTicketForm.vue?vue&type=script&lang=js"
export * from "./CreateTicketForm.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_2839a0f4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__